/**
 * Temporary static menu mirroring the legacy client's sidebar (old backend GetCustomerMenu response).
 * Used while the enterprise backend has no menu/permission API yet.
 * Financial workspace entries are enabled now that they use the enterprise
 * Entity-context API contract.
 */
export const MOCK_MENU: MenuItem[] = [
  {
    id: 'main-menu',
    label: 'Main Menu',
    icon: '',
    route: '',
    visible: true,
    enabled: true,
    type: 'Section',
    children: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'dashboard-sidebar',
        route: '/dashboard',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'wallets',
        label: 'Wallets',
        icon: 'virtual-account-sidebar',
        route: '/wallets',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'receiving-accounts',
        label: 'Receiving Accounts',
        icon: 'customer-request-sidebar',
        route: '/receiving-accounts',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'fx',
        label: 'FX',
        icon: 'fx-sidebar',
        route: '/fx',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'cards',
        label: 'Cards',
        icon: 'card-sidebar',
        route: '/cards',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'transactions',
        label: 'Transactions',
        icon: 'transaction-sidebar',
        route: '/transactions',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'cashback',
        label: 'Cashback',
        icon: 'cashback-sidebar',
        route: '/cashback',
        visible: true,
        enabled: false,
        type: 'Link',
      },
    ],
  },
  {
    id: 'other-menu',
    label: 'Other',
    icon: '',
    route: '',
    visible: true,
    enabled: true,
    type: 'Section',
    children: [
      {
        id: 'profile',
        label: 'Profile',
        icon: 'user-sidebar',
        route: '/profile',
        visible: true,
        enabled: true,
        type: 'Link',
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: 'settings-sidebar',
        route: '/settings',
        visible: true,
        enabled: false,
        type: 'Link',
      },
    ],
  },
];
